import { useSyncExternalStoreWithSelector } from "use-sync-external-store/with-selector";
import { store } from "@/store/index";
import { toHostPublicState, type HostPublicState } from "@/federation/HostPublicState";

const subscribe = (onStoreChange: () => void): (() => void) => store.subscribe(onStoreChange);
const getSnapshot = (): HostPublicState => toHostPublicState(store.getState());

const freezeIfObject = <T>(value: T): Readonly<T> => {
  if (value !== null && typeof value === "object" && !Object.isFrozen(value)) {
    Object.freeze(value);
  }
  return value;
};

export function useHostSelector<T>(
  selector: (state: HostPublicState) => T,
  isEqual?: (a: T, b: T) => boolean
): Readonly<T> {
  const selected = useSyncExternalStoreWithSelector<HostPublicState, T>(
    subscribe,
    getSnapshot,
    null,
    selector,
    isEqual
  );
  return freezeIfObject(selected);
}
